import selectInsurance from 'utils/selectInsurance';
import getPatientDob1 from 'utils/print/getPatientDob1';

const getInsuranceInsuredsDob1 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  switch (selectedInsuranceRelationToInsured) {
    case 'Self':
      return getPatientDob1({
        ...otherProps,
        patient,
        insurance,
      });
    case 'Spouse':
    case 'Child':
    case 'Other':
      return selectedInsurance['Related Date of Birth']
        ? selectedInsurance['Related Date of Birth'].replace(/[/]/g, '').substring(0, 2)
        : null;
    default:
      return null;
  }
};

export default getInsuranceInsuredsDob1;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsDob1.js